export const SUBPATH_TYPES = {
  'articles': 'articles',
  'sections': 'sections',
  '404': '404',
};

export const SUBPATH_PARAMS = {
  articles: 'articleSlug',
  sections: 'sectionSlug',
};

export const SUBPATH_NAMES = {
  'articles': '/articles/[articleSlug]',
  'sections': '/sections/[sectionSlug]',
  '404': '/404',
};

export const APP_DOMAINS: {
  default: string;
  zendesk: string;
  no_proto: string;
} = {
  default: 'https://help.sumup.com',
  zendesk: 'https://support.sumup.com',
  no_proto: 'help.sumup.com',
};

export const COOKIES: {
  APP_LOCALE: string;
} = {
  APP_LOCALE: 'APP_LOCALE',
};

export const EU_DTS_ENABLED_COUNTRIES = [
  'en-IE',
  'de-DE',
  'fr-FR',
  'nl-NL',
  'it-IT',
  'es-ES',
];

export const BR_DTS_ENABLED_ARTICLES = [
  '70auBV1suiIVTTysHkVlCi',
  'wFOR7xKT1eZRkYfsR6iEI',
  '7ovdM9A05RmHjIuDDvzN5H',
];

export const DTS_ENABLED_ARTICLES = ['1fH1DQy2SCfsXvrdb76MS0'];

export const ICONS_BASE_URL = 'https://circuit.sumup.com/icons/v2';
